const countyConfigCountyEfileReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_COUNTY_EFILE':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigCountyEfileReducer;
